export default __webpack_public_path__ + "static/media/ashok.a4237af5.jpg";